export const canUpgradeForReason = ({ plan, upgradeReason }) => {
    let result = true;
    switch (upgradeReason) {
        case "email-support": {
            result = (plan === null || plan === void 0 ? void 0 : plan.type) === "Free";
            break;
        }
        case "live-zaps": {
            result = (plan === null || plan === void 0 ? void 0 : plan.zapLimit) !== -1;
            break;
        }
        case "multistep": {
            result = !(plan === null || plan === void 0 ? void 0 : plan.hasMultiStepZaps);
            break;
        }
        case "paths": {
            result = !(plan === null || plan === void 0 ? void 0 : plan.hasPaths);
            break;
        }
        case "premium": {
            result = !(plan === null || plan === void 0 ? void 0 : plan.hasPremiumApps);
            break;
        }
        case "premium-limit": {
            result = !(plan === null || plan === void 0 ? void 0 : plan.hasPremiumApps) || (plan === null || plan === void 0 ? void 0 : plan.premiumAppsLimit) !== -1;
            break;
        }
        case "tasks":
        case "tasks-low": {
        }
    }
    return Boolean(result);
};

// @zapier/upsells@8.0.1 (466b4077f)
